import { render, staticRenderFns } from "./PurchaseBlock.vue?vue&type=template&id=3a05c646&scoped=true"
import script from "./PurchaseBlock.vue?vue&type=script&lang=js"
export * from "./PurchaseBlock.vue?vue&type=script&lang=js"
import style0 from "./PurchaseBlock.vue?vue&type=style&index=0&id=3a05c646&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05c646",
  null
  
)

export default component.exports